export const BackgroundJobProgressFragment = gql`
  fragment BackgroundJobProgressFragment on BackgroundJob {
    id
    usingLoader
    type
    status
    isAcknowledged
    isInTerminalStatus
    viewId
    recordTypeId
    totalCount
    processedCount
    successCount
    errorCount
  }
`
